import { render, staticRenderFns } from "./ArrivalDepartureListItem.vue?vue&type=template&id=c593f924"
import script from "./ArrivalDepartureListItem.vue?vue&type=script&lang=ts"
export * from "./ArrivalDepartureListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports